import Vue from 'vue'
import store from '@/store'

const URL = store.state.externalApiUrl + '/api/kopiketjil/'

export const login = () => {
  const params = {
    'email': 'admin@admin.com',
    'password': 'adminadmin'
  }

  return Vue.http.post(URL + 'login', params, null)
    .then((response) => {
      store.commit('LOGINEX', response.body.api_key)
      console.log(store.state)
    })
}



// WEBPACK FOOTER //
// ./src/services/external/auth.js